<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full mb-base lg:mb-0 lg:w-1/3">
        <vx-card>
          <div class="flex items-center pb-4 mb-4 border-b border-l-0 border-r-0 border-t-0 d-theme-border-grey-light border-solid">
            <vs-avatar size="65px" class="border-2 shadow border-solid border-white mt-2 mr-2 flex-shrink-0" :src="teacher.image" @click="viewProfile(teacher.id)"/>
            <div class="flex flex-col">
              <h4 class="mb-1 cursor-pointer" @click="viewProfile(teacher.id)">{{ teacher.name }}</h4>
              <span class="text-sm">{{ teacher.email }}</span>
            </div>
          </div>
          <h4 class="mb-2">
            {{ getCourseDetails.name }} <span class="text-gray">({{ getCourseDetails.id }})</span>
          </h4>
          <h6 v-if="isTeacher" class="mb-2">المجموعات ({{ courseGroups.join(', ') }})</h6>
          <h6 v-else class="mb-2">المجموعة {{ getFirstGroup }}</h6>
          <p class="leading-loose">{{ getCourseDetails.description }}</p>
        </vx-card>
      </div>
      <div class="vx-col w-full mb-base lg:mb-0 lg:w-1/3">
        <announcements></announcements>
      </div>
      <div class="vx-col w-full mb-base lg:mb-0 lg:w-1/3">
        <activity-timeline></activity-timeline>
      </div>
    </div>
  </div>
</template>

<script>
    import ActivityTimeline from '@/views/components/ActivityTimeline'
    import Announcements from '@/views/components/announcements/Announcements'
    import Helper from '@/components/helper'

    export default {
        components: { Helper, Announcements, ActivityTimeline },
        computed: {
            teacher() {
                return this.isTeacher ? this.user : this.getCourseDetails.groups[0].teacher
            },
            courseGroups() {
                return this.getCourseDetails.groups.map(group => group.group)
            }
        },
  }
</script>
